<template>
  <v-card
    ripple
    class="card--programmed-activity"
    @click="openMirrorItemDetails"
  >
    <div class="card-content">
      <div class="card-content-header">
        <div
          class="card-content-header-item"
          :class="textColorClassFromType('card', activityType)"
        >
          <v-icon>mdi-label</v-icon>
          {{ itemTypeDisplay(activityType) }}
        </div>

        <div class="card-content-header-item">
          <v-icon>mdi-television</v-icon>
          {{ activity.program_tag }}
        </div>
      </div>

      <div class="card-content-title">
        {{ activity.title }}
      </div>

      <div class="card-content-metadata">
        <div class="card-content-metadata__item">
          <div>tCAB</div>
          <div>{{ formatSeconds(activity.speaking_time) }}</div>
        </div>

        <div class="card-content-metadata__item">
          <div>tVT</div>
          <div>{{ formatSeconds(activity.tape_time) }}</div>
        </div>

        <div class="card-content-metadata__item">
          <div>tMAT</div>
          <div>{{ formatSeconds(activity.total_time) }}</div>
        </div>
        <v-icon>keyboard_arrow_right</v-icon>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatSeconds } from '@/utils/date.js';
import {
  itemTypeDisplay,
  textColorClassFromType,
} from '@/utils/mirrorFormatter.js';
import { actions, categories } from '@/constants/analytics.js';
export default {
  name: 'ProgrammedActivityCard',
  props: {
    activity: Object,
    activityType: String,
  },
  methods: {
    formatSeconds,
    itemTypeDisplay,
    textColorClassFromType,

    openMirrorItemDetails() {
      this.sendMirrorCardAnalytics();
      this.$store.dispatch(
        'mirror/handleLastMirror',
        `mirror-${this.activity.id}`,
      );
      this.openMirror();
    },
    async openMirror() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.$router.push(
          `/mirror/${this.activity.place}/${this.activity.program_tag}`,
        );
      } else {
        await this.$store.dispatch('mirror/selectMirror', {
          programName: this.activity.program_tag,
          place: this.activity.place,
        });

        this.$router.push({
          path: `/mirror/detail/${this.activity.place}/${this.activity.program_tag}`,
          query: { selectedSlugId: this.activity.id },
        });
      }
    },

    sendMirrorCardAnalytics() {
      this.$store.dispatch('analyticsEvent', {
        category: categories.mirror_activity,
        action: actions.mirrorActivityCardClicked,
        label: `${this.activity.place}-${this.activity.program_tag}-${this.activity.title}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/mirror-card.scss';
</style>
